import { Modal, Text, Button, Icon } from '@desygner/ui-common-components';
import React from 'react';
import ReactAppBuilder from 'src/utils/react-app-builder';

import styled, { useTheme } from 'styled-components';

const StyledKeepButton = styled.div`
  button{
    box-shadow:${({ theme }) => `0 0 0 ${theme.Border.Size.Small}px #E8E8E8 inset`};
    color: #000000
  }
`;

const StyledSelectButton = styled.div`
  button {
    color: white;
    border: none;
    cursor: pointer;

    ${({ $isWorkspace, theme }) => $isWorkspace
? `
      background: ${theme.Color.Brand.Primary};
      transition: background-color ${theme.Transition.Timing.Out};

      &:hover {
        background-color: ${theme.Color.Brand.Darkest};
        transition: background-color ${theme.Transition.Timing.In};
      }
    `
: `
      background: linear-gradient(92deg, #6659E3 1.74%, #2A3EE1 50%);
      background-position: left;
      background-size: 200% 100%;
      transition: background-position ${theme.Transition.Timing.Out};

      &:hover {
        background: linear-gradient(92deg, #6659E3 1.74%, #2A3EE1 50%);
        background-position: right;
        background-size: 200% 100%;
        transition: background-position ${theme.Transition.Timing.In};
      }
    `
}
  }
`;

const StyledCloseButton = styled.div`
  position: absolute;
  right: 0;
  cursor: pointer;
`;

const StyledTitleContainer = styled.div`
 display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: ${({ theme }) => theme.Border.Radius.Small}px;
`;

const StyledButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.Spacing.Size.Small}px;
  justify-content: center;
`;

export class SwitchEditorModal extends ReactAppBuilder {
  modalId = 'editor-switch-modal';

  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
    this.onClick = null;
    this.keepOption = () => {};
    this.keepCurrentEditor = false;
  }

  createButton (onClick) {
    const tmpDiv = document.createElement('div');
    tmpDiv.innerHTML = `<button id="try-new-editor" class="auto-collapse" data-action="try-new-editor" data-id="try-new-editor">
    <icon>
      <svg fill="#fff">
        <use xlink:href="#magic-pen"></use>
      </svg>
    </icon>
    <span>
        ${INKIVE.TranslateHelper.translate('top_submenu.file.try_new_editor')}
    </span>
  </button>`;

    const referenceNode = document.querySelector('header .options [data-value="project-name"]');
    referenceNode.parentNode.insertBefore(tmpDiv.firstChild, referenceNode.nextSibling);

    document.querySelector('header button#try-new-editor').addEventListener('click', () => onClick());
  }

  mountApp ({ onClick, keepOption, isKeepCurrentEditor }) {
    this.onClick = onClick;
    this.keepOption = keepOption;
    this.keepCurrentEditor = isKeepCurrentEditor;

    this.mountPortalContainer();

    super.mountApp(this.App);
  }

  mountPortalContainer () {
    const existingContainer = document.getElementById(this.modalId);

    if (existingContainer) {
      return existingContainer;
    }

    const container = document.createElement('div');

    container.id = this.modalId;
    container.style.zIndex = 999999;
    container.style.position = 'relative';

    document.body.appendChild(container);

    return container;
  }

  closeApp () {
    this.onClick = null;
    document.getElementById(this.modalId)?.remove?.();
    super.closeApp(this.App);
  }

  mapProps = () => {
    const isWorkspace = !INKIVE.Helpers.isDesygnerProject();
    const newEditorBanner = isWorkspace
      ? 'https://static.desygner.com/assets/img/new-editor-workspace-banner.jpg'
      : 'https://assets.fluer.com/assets/img/panels/new_editor_modal.jpg';

    return {
      isWorkspace,
      newEditorBanner
    };
  };

  App = () => {
    const theme = useTheme();
    const { isWorkspace, newEditorBanner } = this.mapProps();

    return (
        <Modal portalTarget={this.mountPortalContainer()}>
          <StyledTitleContainer>
            <Text size={'BodyLargeHeavy'}>{INKIVE.TranslateHelper.translate('modal.editor.new_editor_version')}</Text>

            <StyledCloseButton>
              <Icon name="cross" color="#00000047" size="medium" onClick={() => this.closeApp()} />
            </StyledCloseButton>
          </StyledTitleContainer>

          <Text size={'Body'}>{INKIVE.TranslateHelper.translate('modal.editor.explore_new_editor')}</Text>
          <StyledImage src={newEditorBanner} alt={ INKIVE.TranslateHelper.translate('modal.editor.new_editor_version')} />

          <StyledButtonsWrapper>
            <StyledKeepButton>
              <Button variant="outline" onClick={this.keepOption}>
                {INKIVE.TranslateHelper.translate('modal.editor.keep_current_version')}
              </Button>
            </StyledKeepButton>

            <StyledSelectButton $isWorkspace={isWorkspace}>
              <Button onClick={this.onClick}>
                <Icon name="magic-pen" color={theme.Color.Neutrals.Paper} size="medium" />
                {INKIVE.TranslateHelper.translate('top_submenu.file.try_new_editor')}
              </Button>
            </StyledSelectButton>
          </StyledButtonsWrapper>
        </Modal>
    );
  };
}
